import { render, staticRenderFns } from "./RotLocScaleSetter.vue?vue&type=template&id=0754a12d&scoped=true&"
import script from "./RotLocScaleSetter.vue?vue&type=script&lang=js&"
export * from "./RotLocScaleSetter.vue?vue&type=script&lang=js&"
import style0 from "./RotLocScaleSetter.vue?vue&type=style&index=0&id=0754a12d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754a12d",
  null
  
)

export default component.exports